/*
 * Buy 1, Get 1 Free — Cooling Mat (Elite theme).
 * Doubles the submitted quantity on this product's Add to Cart form, in a
 * single request, before Elite's own product-form.js reads the FormData.
 * Pricing correctness (making half the units free) is handled entirely by
 * the native Shopify automatic discount "Buy 1, Get 1 Free — Cooling Mat" —
 * this script only affects how many units get added to the cart.
 *
 * Uses form.elements (not form.querySelector) because Elite's quantity
 * input is associated to the form via the `form="..."` attribute rather
 * than being a DOM descendant of the <form> element.
 */
(function () {
  /* Dog/XS, Dog/XXL, Cat/XS, Cat/XXL — excluded from the BOGO discount (see Shopify Discounts). */
  var INELIGIBLE_VARIANT_IDS = ['58087527514495', '58087527678335', '58122873438591', '58122873602431'];

  function doubleQuantity(event) {
    var form = event.target;
    if (!form || form.getAttribute('action') !== '/cart/add') return;

    var quantityInput = form.elements ? form.elements.namedItem('quantity') : null;
    if (!quantityInput) return;

    var variantInput = form.elements ? form.elements.namedItem('id') : null;
    var variantId = variantInput ? variantInput.value : '';
    if (INELIGIBLE_VARIANT_IDS.indexOf(variantId) !== -1) return;

    var requested = parseInt(quantityInput.value, 10) || 1;
    quantityInput.value = requested * 2;
    quantityInput.dataset.caniorasBogoPaidQuantity = requested;
  }

  document.addEventListener('submit', doubleQuantity, true);
})();
